export default __webpack_public_path__ + "static/media/(29).0b28bc0f.jpeg";